var _path, _mask, _g, _mask2, _g2, _path2, _path3, _circle, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewCollaborate = function SvgViewCollaborate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 661 576",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M0 0h661v576H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-collaborate_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M255 0h406v307H255z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-collaborate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M817.812 181.482H468.864A129.192 129.192 0 01598.051 52.351H947a129.192 129.192 0 01-129.188 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M630.511 129.131H281.565A129.193 129.193 0 01410.755 0h348.946a129.18 129.18 0 01-129.19 129.131zM520.014 292H359.51a129.193 129.193 0 0137.853-91.31 129.17 129.17 0 0191.316-37.821h160.504a129.182 129.182 0 01-37.85 91.312A129.163 129.163 0 01520.014 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-collaborate_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M0 292h463.099v284H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-collaborate_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M206.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C271.533 562.928 239.889 576 206.894 576zM40.252 434h-337.045c.013-32.915 13.166-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.218-36.342h337.035a123.527 123.527 0 01-9.502 47.495 124.062 124.062 0 01-27.049 40.261 124.793 124.793 0 01-40.48 26.897A125.31 125.31 0 0140.252 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M302.641 496.685H47.333c.013-32.915 13.157-64.478 36.541-87.748 23.384-23.27 55.094-36.342 88.157-36.342h255.248a123.512 123.512 0 01-9.466 47.497 123.969 123.969 0 01-27.015 40.268 124.606 124.606 0 01-40.447 26.898 125.055 125.055 0 01-47.71 9.427z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.689 369.278c10.561-4.393 17.88-14.854 17.88-26.988 0-16.11-13.07-29.29-29.276-29.29-16.207 0-29.277 13.076-29.277 29.29 0 12.134 7.424 22.595 17.88 26.988C214.729 373.776 198 393.443 198 417.084h100.69c0-23.641-16.73-43.308-39.001-47.806zm-11.187 45.714l-9.097-9.729 7.424-26.884-.941-6.276h5.228l-.941 6.276 7.423 26.884-9.096 9.729zM445.475 372.732h9.238c-4.234-3.479-1.539-22.037-.385-29.189.385-2.127.578-4.253.193-6.379C452.596 323.632 441.049 313 426.808 313c-12.895 0-23.865 8.892-26.944 20.877-.962 3.287-.962 6.959-.192 10.246 1.347 6.959 3.849 23.39-.77 28.416h9.43C389.664 378.725 376 396.316 376 417h102c0-20.684-13.664-38.275-32.525-44.268zm-.577 24.164L427 412.941l-17.898-16.045 1.924-11.985-14.049-4.06 11.932-7.925 17.899 40.015 17.898-40.015 11.932 7.925-14.049 4.06 2.309 11.985z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334 281v-21.5M248 301v-20.5h179V301",
    stroke: "#33BB40",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 221,
    r: 43,
    fill: "#33BB40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.908 193h2.172v7.6h-2.172zM340.198 194.086l2.012.818-2.86 7.04-2.013-.817zM325.941 194.086l-2.012.818 2.86 7.04 2.013-.817zM347.91 198.429l1.599 1.47-5.144 5.595-1.6-1.47zM318.229 198.429l-1.599 1.47 5.144 5.595 1.6-1.47zM353.876 204.943l.989 1.934-6.767 3.46-.989-1.934zM312.264 204.943l-.989 1.934 6.767 3.46.989-1.934zM356.855 213.629l.176 2.165-7.575.616-.176-2.165zM309.283 213.629l-.176 2.165 7.575.616.176-2.165zM339.628 241.428c0-.614-.498-1.112-1.112-1.112h-11.434c-.614 0-1.111.498-1.111 1.112v.119c0 .613.497 1.111 1.111 1.111h11.434c.614 0 1.112-.498 1.112-1.111v-.119zM339.628 244.159c0-.614-.498-1.111-1.112-1.111h-11.434a1.11 1.11 0 00-1.111 1.111v.119a1.11 1.11 0 001.111 1.111h11.434c.614 0 1.112-.497 1.112-1.111v-.119zM339.628 246.89c0-.613-.498-1.111-1.112-1.111h-11.434c-.614 0-1.111.498-1.111 1.111v.119c0 .614.497 1.112 1.111 1.112h11.434c.614 0 1.112-.498 1.112-1.112v-.119zM332.766 250.261c1.554 0 2.949-.579 3.91-1.75h-7.821c.961 1.171 2.356 1.75 3.911 1.75zM345.505 221.196h-.002c.451-1.561.695-2.817.695-4.309 0-7.4-5.999-13.42-13.399-13.42-7.4 0-13.4 6.03-13.4 13.43 0 1.492.245 2.738.695 4.299h-.002c.003 0 .006-.028.009-.021.373 1.106.906 2.127 1.539 3.083 1.933 3.498 3.94 6.117 4.33 11.686v1.996c0 1.099.854 1.985 1.953 1.985h9.685c1.099 0 1.99-.888 1.99-1.988 0-6.982 2.228-9.809 4.378-13.701a13.062 13.062 0 001.521-3.062c.003-.006.006.022.008.022z"
  })));
};

export default SvgViewCollaborate;